import React from "react";
import moment from "moment-jalaali";
import Style from "./TransactionList.module.scss";
import { separate } from "../../../Utils/SeprateNumber/SeprateThreeNumber";
const TransactionList = ({ data }) => {
  return (
    <ul className={Style.ListHolder}>
      {data.map((item) => {
        return (
          <li
            key={item.id}
            className={Style.TransactionPart}
            style={
              item.payment_type_detail?.cardnumbermasked !== null
                ? { border: "1px solid green" }
                : { border: "1px solid red" }
            }
          >
            <section className={Style.persianDetail}>
              <div>
                <p>عملیات</p>
                <p>تاریخ</p>
                <p>شبکه پرداخت</p>
                {item.payment_type_detail?.cardnumbermasked !== null ? (
                  <p>شماره کارت</p>
                ) : null}
                <p>مبلغ</p>
              </div>
              <div>
                <p>
                  {item.payment_type_detail?.cardnumbermasked !== null ? (
                    <span style={{ color: "green", fontWeight: "600" }}>
                      موفق
                    </span>
                  ) : (
                    <span style={{ color: "red", fontWeight: "600" }}>
                      ناموفق
                    </span>
                  )}
                </p>
                <p style={{ direction: "ltr" }}>
                  {" "}
                  {moment
                    .unix(parseInt(item.date))
                    .format("jYYYY/jM/jD--HH:mm")}
                </p>
                <p>{item.payment_type}</p>
                {item.payment_type_detail?.cardnumbermasked !== null ? (
                  <p style={{ direction: "ltr" }}>
                    {item.payment_type_detail?.cardnumbermasked}
                  </p>
                ) : null}
                <p>{separate(item.payment_type_detail?.amount)} تومان</p>
              </div>
            </section>
            <ul className={Style.transactionDetail}>
              <li style={{ width: "100%", textAlign: "center" }}>
                اطلاعات بیشتر
              </li>
              <li style={{ width: "100%" }}>
                <hr />
              </li>
              {Object.entries(item?.payment_type_detail).map(([key, value]) => {
                return (
                  <li className={Style.KeyValueHolder}>
                    <p>{key}</p> <span>{value}</span>
                  </li>
                );
              })}
            </ul>
          </li>
        );
      })}
    </ul>
  );
};

export default TransactionList;
